export default __webpack_public_path__ + "static/arrow-concept-2c11bfbd4533c9d44b1a83500b7eb552.png";